import { GtmHeadScript } from '../../config/gtm-head-script';
import { InlineManualScript } from '../../config/inline-manual-script';

export function InitScripts() {
  return (
    <>
      <GtmHeadScript />
      <InlineManualScript />
    </>
  );
}
